import { env } from '@/env';
import { NotificationId } from '@/modules/api/codegen';
import { useUserNotification } from '@/modules/notifications/hooks';
import { useIsFreeTier } from '@/modules/settings/hooks';

import { hasEnteredReviewPrizepool } from '../services/eligibility';

export const useIsEligibleForReviewPrizepool = () => {
    const isFreeTier = useIsFreeTier();
    const { isLoading, notification } = useUserNotification(NotificationId.reviewPrizepool);

    return !env.VITE_DEMO && isFreeTier && !isLoading && !hasEnteredReviewPrizepool(notification);
};
